import * as React from "react";
// style, design
import BaseTable from "src/components/Lists/Base/FinalTable/BaseTable";
import columnDefs from "./listDefs";

import LoanSubTable from "./SubTable";

// store, state

import { constants, detailUrl } from "../../../store/loan";

export default ({
  persistantQuery,
  isBare,
  ignoreLocalStorage,
  tableId,
  onRowClicked,
  checkRowHighlighted,
  onRowSelected,
}) => {
  const columns = React.useMemo(() => columnDefs(), [persistantQuery]);

  const renderSubRow = ({ row, tableWidth }) => {
    return <LoanSubTable loan={row.original} />;
  };

  const badges = {};
  const filters = {};

  return (
    <BaseTable
      tableId={tableId || "loan_full_table"}
      title={"Hyresavtal"}
      onRowClickedWithDetail={(obj) =>
        detailUrl({
          id: obj.id,
        })
      }
      getContentForExpandedRow={(row) => renderSubRow(row)}
      {...{
        isBare,
        ignoreLocalStorage,
        onRowClicked,
        columns,
        persistantQuery,
        badges,
        filters,
        constants,
        checkRowHighlighted,
        onRowSelected,
      }}
    />
  );
};
